<template>
  <section>
      <!-- <grid-filters v-if="!isQuoteTab || !isPartTab" /> -->
      <grid-component
        isResizable
        isReorderable
        :canEdit="checkClaim(CAN_EDIT_QUOTES)"
        :canDelete="checkClaim(CAN_DELETE_QUOTES)"
        :gridId="gridId"
        :itemData="itemData"
        :fields="fields"
        :onEdit="pushToDetails"
        :onDelete="onDelete"
        :handleRowClick="onRowClick"
        :navigationField="'quoteId'"
        :styleCustom="'height: 160px'"
      />
  </section>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import debounce from 'lodash/debounce';

// import { dateTime, date } from '@/shared/filters';
import { SORT_ORDER, GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID } from '@/shared/constants';
// import { sortChange, prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';

// import AddQuote from '@/pages/Quotes/components/AddQuote';
// import GridFilters from '@/pages/Quotes/components/GridFilters';
import GridComponent from '@/shared/components/GridComponent';

import gridFields from './fields';

export default {
  components: {
    GridSettings,
    // AddQuote,
    // GridFilters,
    GridComponent
  },
  props: {
    companyId: {
      type: [Number, String],
      default: 0,
    },
    partId: {
      type: [String, Number],
      default: 0,
    },
    partNumber: {
      type: String,
      default: null,
    },
    isQuoteTab: {
      type: Boolean,
      default: false
    },
    isPartTab: {
      type: Boolean,
      default: false
    },
    quoteLineId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      // prepareColumnsData,
      filtersVisible: false,
      fields: gridFields,
      gridId: GRID_ID.QUOTE_LINES_TAB_GRID,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      filters: {}
    };
  },
  computed: {
    ...mapGetters('quotes', [
      'quotes',
      'searchQuery',
      'selectedQuoteId',
      'quotesFiltered'
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    filterButtonName() {
      return this.filtersVisible ? 'Hide advanced' : 'Advanced';
    },
    // emptyMessage: function() {
    //   return this.searchQuery
    //     ? `No company <span class="text-primary">${this.searchQuery}</span> found`
    //     : 'No companies found';
    // },
    // gridSettings() {
    //   return this.gridSettingsById(this.gridId);
    // },
    itemData() {
      const items = (this.isQuoteTab || this.isPartTab) ? this.quotesFiltered : this.quotes;

      return items.map((quote) => ({ ...quote, selected: quote.id === this.selectedRowItemId }));
    },
  },
  // filters: {
  //   dateTime,
  //   date,
  // },
  methods: {
    // ...mapMutations('quotes', ['setFilters', 'setQuotesFiltered']),
    ...mapMutations('quotes', ['setItem']),
    ...mapActions('quotes', [
      'getQuotesByPart',
      'getQuotesByQuoteLine',
      'getCompanyQuoteLines',
      'select'
    ]),
    ...mapActions('account', ['saveGridSettings']),
    ...mapActions('quoteLines', ['deleteQuoteLine']),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
    },
    pushToDetails(row) {
      this.$router.push({
        name: 'quotes.edit',
        params: { id: row.quoteId },
      });
    },
    async onDelete(item) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete quoteLine with id :${item.id}?`});
      if (deleteConfirmed) {
        const result = await this.deleteQuoteLine(item.id);
        if (this.companyId) {
          this.getCompanyQuoteLines(this.companyId);
        } else if (this.partId) {
          this.getQuotesByPart(this.partId);
        } else if (this.quoteLineId) {
          this.getQuotesByQuoteLine(this.quoteLineId);
        }
      }
    },
  },
  watch: {
    async companyId() {
      // this.setQuotesFiltered([]);
      this.setItem({ resource:'quotesFiltered', payload: [] });
      if (this.isQuoteTab) {
        await this.getCompanyQuoteLines(this.companyId);
      }
    },
    async partId() {
      // this.setQuotesFiltered([]);
      this.setItem({ resource:'quotesFiltered', payload: [] });
      if (this.isQuoteTab || this.isPartTab) {
        await this.getQuotesByPart(this.partId);
      }
    },
    async quoteLineId() {
      // this.setQuotesFiltered([]);
      this.setItem({ resource:'quotesFiltered', payload: [] });
      if (this.isQuoteTab) {
        await this.getQuotesByQuoteLine(this.quoteLineId);
      }
    }
  },
  mounted() {
    if (this.isQuoteTab || this.isPartTab) {
      // this.setQuotesFiltered([]);
      this.setItem({ resource:'quotesFiltered', payload: [] });
      if (this.companyId) this.getCompanyQuoteLines(this.companyId);
      if (this.partId) this.getQuotesByPart(this.partId);
      if (this.quoteLineId) this.getQuotesByQuoteLine(this.quoteLineId);
    }
  },
  // beforeDestroy() {
  //   this.select({ id: null, isChecked: false });
  // },
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
  min-width: 800px;
}
</style>
